export const currencies = {
  US: 'USD',
  EU: 'EUR',
  JP: 'JPY',
};
